import { render } from "./img-box.vue?vue&type=template&id=556f2db8"
import script from "./img-box.vue?vue&type=script&lang=js"
export * from "./img-box.vue?vue&type=script&lang=js"

import "./img-box.vue?vue&type=style&index=0&id=556f2db8&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/img-box.vue'],['render',render],['__file',"img-box.vue"]])

export default __exports__